var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0916 15.9084L14 12.8417C15.2001 11.3454 15.7812 9.44613 15.624 7.53446C15.4667 5.62279 14.583 3.84403 13.1546 2.56391C11.7261 1.2838 9.86149 0.599634 7.94408 0.652101C6.02668 0.704568 4.20225 1.48968 2.84593 2.84599C1.48962 4.20231 0.704507 6.02674 0.65204 7.94415C0.599573 9.86155 1.28374 11.7262 2.56385 13.1546C3.84397 14.5831 5.62273 15.4668 7.5344 15.6241C9.44606 15.7813 11.3453 15.2001 12.8416 14L15.9083 17.0667C15.9858 17.1448 16.078 17.2068 16.1795 17.2491C16.281 17.2914 16.39 17.3132 16.5 17.3132C16.61 17.3132 16.7189 17.2914 16.8205 17.2491C16.922 17.2068 17.0142 17.1448 17.0916 17.0667C17.2418 16.9113 17.3258 16.7037 17.3258 16.4875C17.3258 16.2714 17.2418 16.0638 17.0916 15.9084ZM8.16665 14C7.01292 14 5.88511 13.6579 4.92582 13.0169C3.96653 12.376 3.21886 11.4649 2.77735 10.399C2.33584 9.33313 2.22032 8.16024 2.4454 7.02868C2.67048 5.89713 3.22605 4.85773 4.04186 4.04192C4.85766 3.22611 5.89707 2.67054 7.02862 2.44546C8.16018 2.22038 9.33307 2.3359 10.399 2.77741C11.4649 3.21892 12.3759 3.9666 13.0169 4.92588C13.6579 5.88517 14 7.01299 14 8.16671C14 9.71381 13.3854 11.1975 12.2914 12.2915C11.1975 13.3855 9.71374 14 8.16665 14Z",
    fill: "#6576FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6a1cfd84.svg";
export { ForwardRef as ReactComponent };